import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const Spinner = ({ addClass }) => (
    <div className="Spinner">
        <div
            className={`Spinner_Container ${addClass}`}
        />
    </div>
);

export { Spinner };

Spinner.defaultProps = {
    addClass: PropTypes.string.isRequired
};

Spinner.propTypes = {
    addClass: PropTypes.string
};
